module.exports = __webpack_public_path__ + "assets/img/tool_short.88ed16e6.png";